import { useState } from 'react';
import { ChevronLeft, ChevronRight, Loader } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function PdfPageReader({ publicationId, imageBaseUrl, pageCount }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [loaded, setLoaded] = useState(false);

  const baseUrl = imageBaseUrl || `${API}/publications/${publicationId}`;

  const goTo = (page) => {
    if (page < 1 || page > pageCount) return;
    setLoaded(false);
    setCurrentPage(page);
  };

  return (
    <div data-testid="pdf-page-reader" className="flex flex-col items-center">
      <div className="relative w-full max-w-3xl bg-white shadow-2xl rounded-lg overflow-hidden border-2 border-[#1B4B5A]/20 min-h-[500px] flex items-center justify-center">
        {!loaded && (
          <div className="absolute inset-0 flex items-center justify-center bg-white">
            <Loader className="w-8 h-8 animate-spin text-[#1B4B5A]" />
          </div>
        )}
        <img
          data-testid="pdf-page-image"
          src={`${baseUrl}/page-image/${currentPage}`}
          alt={`Page ${currentPage}`}
          className="w-full h-auto select-none"
          draggable={false}
          onLoad={() => setLoaded(true)}
          onError={() => setLoaded(true)}
        />
      </div>

      <div className="flex items-center gap-4 mt-6">
        <button
          data-testid="pdf-page-prev-button"
          onClick={() => goTo(currentPage - 1)}
          disabled={currentPage <= 1}
          className="flex items-center gap-1 bg-[#1B4B5A] text-white px-4 py-2 rounded-lg font-bold disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#143a45] transition-all"
        >
          <ChevronLeft className="w-4 h-4" /> Prev
        </button>
        <span data-testid="pdf-page-indicator" className="font-bold text-[#1B4B5A]">
          Page {currentPage} of {pageCount}
        </span>
        <button
          data-testid="pdf-page-next-button"
          onClick={() => goTo(currentPage + 1)}
          disabled={currentPage >= pageCount}
          className="flex items-center gap-1 bg-[#1B4B5A] text-white px-4 py-2 rounded-lg font-bold disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#143a45] transition-all"
        >
          Next <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
